/*
 * <m-featured-collection-2> — the slider behaviour of <m-featured-collection>
 * with a progress bar instead of bullets.
 *
 * A subclass, not a copy. Everything this section needs beyond the pagination
 * type — load more, infinite scroll, the flash-sale countdown, the mobile
 * breakpoint teardown, the section re-fetch — is identical, and duplicating
 * 290 lines to change one option is how the two drift apart.
 *
 * assets/featured-collection.js must be loaded first; the section file loads
 * both, in that order. Both are `defer`, which preserves document order.
 */

(() => {
  const Base = customElements.get("m-featured-collection");

  if (!Base) {
    console.error("m-featured-collection-2: assets/featured-collection.js must load first");
    return;
  }

  if (customElements.get("m-featured-collection-2")) return;

  class MFeaturedCollection2 extends Base {
    /* Overridden wholesale rather than called through: Swiper takes its options
       once, at construction, and the base method both builds them and news up
       the instance. The only differences from the parent are marked below. */
    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      slideContainer && slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        /* Difference 1: `loop` is off. A progress bar has to run from empty to
           full, and a looping slider has no last slide to fill it — the bar
           would jump back mid-gesture with nothing on screen to explain it.
           Bullets did not have this problem, which is why the parent loops. */
        loop: false,
        /* Difference 2: the pagination is the bar, and it is always on — this
           section treats the controls as part of its layout rather than as two
           toggles, so there is no showPagination / showNavigation to read. */
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1024: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          /* Difference 3: no `init` handler. The parent used it to measure the
             first image and centre the overlay arrows on it; these arrows sit
             in the header, in flow, and need no offset. */
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
      nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());

      this.swiper = slideContainer && slideContainer.swiper;
    }
  }

  customElements.define("m-featured-collection-2", MFeaturedCollection2);
})();
